<template>
	<o-button outlined @click="openBrowse">
		<slot>Browse</slot>
	</o-button>
</template>
<script>
	import { ref, inject, getCurrentInstance } from "vue";
	import browseExplorer from "@/components/modals/browseExplorer.vue";
	export default {
		emits: ["input", "click"],
		setup(props, context) {
			const oruga = inject("$oruga");

			const openBrowse = () => {
				context.emit("click");
				oruga.modal.open({
					parent: getCurrentInstance(),
					component: browseExplorer,
					trapFocus: true,
					events: {
						select: (result) => {
							context.emit("input", result);
						}
					}
				});
			};

			return {
				openBrowse
			};
		}
	};
</script>